var _a, _b;
import debounce from 'debounce';
// tslint:disable:no-submodule-imports ordered-imports
import 'preact/devtools';
import StyleContext from 'isomorphic-style-loader/StyleContext';
import React from 'react';
import { hydrate, render } from 'react-dom';
import { Provider } from 'react-redux';
import { CLIENT_INTERACTION, URL_CHANGE, WINDOW_RESIZE } from './actions';
import { reportFlexEvent } from './utils/reportFlexEvent';
import cleanDeeplink from './utils/cleanDeeplink';
import ErrorBoundary from './components/ErrorBoundary';
import KeyboardShortcutsListener from './components/KeyboardShortcutsListener';
import PushNotificationServiceWorker from './components/PushNotificationServiceWorker';
import configureStore from './store/configureStore';
import { handleNetworkConnectivityLost, handleNetworkConnectivityRecovered, globals, initSkyfire, rewriteDeeplink } from './utils';
import TemplateContainer from './views/TemplateContainer';
const { document, window } = globals;
const store = configureStore(window.amznMusic.state);
initSkyfire(store);
document.documentElement.lang = (_b = (_a = store.getState().Authentication.displayLanguageId) === null || _a === void 0 ? void 0 : _a.substring(0, 2), (_b !== null && _b !== void 0 ? _b : ''));
window.onpopstate = () => {
    const newUrl = rewriteDeeplink(window.location.pathname + window.location.search, false, []);
    store.dispatch({ type: URL_CHANGE, payload: { newUrl } });
};
window.onresize = debounce(() => {
    store.dispatch({
        type: WINDOW_RESIZE,
        payload: { windowHeight: window.innerHeight, windowWidth: window.innerWidth },
    });
}, 100);
window.onerror = async (msg, url, lineNo, columnNo, error) => {
    var _a, _b, _c, _d, _e, _f;
    const { UAParser } = await import(/* webpackChunkName: "metrics" */ 'ua-parser-js');
    const ua = new UAParser(globals.navigator.userAgent);
    const browser = ua.getBrowser();
    const overlayTemplates = store.getState().TemplateStack.overlayTemplates;
    const currentTemplate = store.getState().TemplateStack.currentTemplate;
    const deeplink = (((_c = (_b = (_a = overlayTemplates[0]) === null || _a === void 0 ? void 0 : _a.innerTemplate) === null || _b === void 0 ? void 0 : _b.templateData) === null || _c === void 0 ? void 0 : _c.deeplink) || ((_e = (_d = currentTemplate) === null || _d === void 0 ? void 0 : _d.templateData) === null || _e === void 0 ? void 0 : _e.deeplink) || '');
    reportFlexEvent(`WebPlayerClientError`, [
        [
            cleanDeeplink(deeplink),
            ua.getOS().name,
            browser.name,
            (_f = error) === null || _f === void 0 ? void 0 : _f.message
        ], [
            Number(browser.major)
        ]
    ], store.getState().Authentication);
};
window.addEventListener('online', () => {
    var _a;
    return (handleNetworkConnectivityRecovered(store, (_a = store.getState().TemplateStack.currentTemplate) === null || _a === void 0 ? void 0 : _a.id));
});
window.addEventListener('offline', () => {
    var _a;
    return (handleNetworkConnectivityLost(store, (_a = store.getState().TemplateStack.currentTemplate) === null || _a === void 0 ? void 0 : _a.id));
});
const onInteraction = debounce(() => {
    store.dispatch({ type: CLIENT_INTERACTION, payload: { timestamp: new Date().getTime() } });
}, 1000);
document.onmousemove = onInteraction;
document.onkeypress = onInteraction;
document.onmousedown = onInteraction;
const insertCss = (...styles) => {
    const removeCss = styles.map((style) => style._insertCss());
    return () => removeCss.forEach((dispose) => dispose());
};
const App = (React.createElement(ErrorBoundary, null,
    React.createElement(StyleContext.Provider, { value: { insertCss } },
        React.createElement(Provider, { store: store },
            React.createElement(TemplateContainer, null),
            React.createElement(KeyboardShortcutsListener, null),
            React.createElement(PushNotificationServiceWorker, null)))));
const bodySelector = document.querySelector('#root') || document.body;
bodySelector.style.height = '100%';
bodySelector.style.position = 'relative';
// render(App, bodySelector);
// Uncomment snippet below when adding hydration for SSR.
if (window.amznMusic.ssr) {
    hydrate(App, bodySelector);
    delete window.amznMusic.state;
}
else {
    render(App, bodySelector);
}
